import classNames from 'classnames';
import { FC } from 'react';

import { formatDate } from '@/helpers/dates';

import { ConditionView } from '../../ConditionView/ConditionView';
import { Status } from '../../Status/Status';
import { Typography } from '../../Typography';
import { BaseCard } from '../model/BaseCard/BaseCard';
import { ReceiptCardProps } from '../model/types';

import { DownloadReceiptButton } from './ActionButtons/DownloadRecieptButton';
import { Row, RowRenderer } from './RowRenderer';

export const ReceiptCard: FC<ReceiptCardProps> = ({
  data: { id, amount, service_name, payed_at },
  onDownloadReceipt,
  informerData,
  variant,
}) => {
  const rows: Row[] = [
    {
      label: 'Дата оплати',
      value: formatDate(payed_at),
      dataTestId: 'receipt-card-date',
    },
    {
      label: 'Сума оплати',
      value: `${amount} грн`,
      dataTestId: 'receipt-card-amount',
    },
  ];

  return (
    <BaseCard
      data-testid="receipt-card"
      className={classNames('service-row-card', `service-row-card--${variant}`)}
      header={
        <div className="service-row-card__header">
          <div data-testid="receipt-card-status" className="service-row-card__status-wrapper">
            <Status status={{ icon: 'check', color: 's-grass', name: 'Завершено', text_color: 'white' }} />
          </div>
          <div className="service-row-card__title-wrapper">
            <Typography data-testid="receipt-card-title" variant="H4">
              {service_name}
            </Typography>
          </div>
        </div>
      }
      body={
        <div className="service-row-card__meta-wrapper">
          <RowRenderer rows={rows} />
        </div>
      }
      informer={informerData}
      actions={[
        <ConditionView key="download-receipt" if={!!onDownloadReceipt}>
          {onDownloadReceipt && <DownloadReceiptButton onClick={() => (id ? onDownloadReceipt(id) : null)} />}
        </ConditionView>,
      ]}
    />
  );
};
